export class UnableToResolveVariantError extends Error {
  public name = 'UnableToResolveVariantError';

  constructor() {
    super("Variant couldn't be determined");
  }
}
export class UnableToLoadProductMetadataError extends Error {
  public name = 'UnableToLoadProductMetadata';

  constructor() {
    super('Product Metadata could not be found');
  }
}
